import {User} from './user';
import {Audited} from "./audited";

export const TenantStatus = {
    ACTIF: 'ACTIF',
    DISABLED: 'DISABLED',
    VALUES: ['ACTIF', 'DISABLED']
};

export const TenantType = {
    LOCATION: 'LOCATION',
    PRESTATION: 'PRESTATION',
    VALUES: ['LOCATION', 'PRESTATION']
};

export class Tenant{
    constructor(obj){
        if(!obj){
            return;
        }

        this.id = obj.id;
        this.name = obj.name;
        this.type = obj.type;
        this.status = obj.status;
        this.users = [];
        if(obj.users){
            obj.users.forEach(u => this.users.push(new User(u)));
        }
    }
}

export class TenantScope extends Audited {
    constructor(obj){
        super(obj);

        if(!obj){
            return;
        }

        if(obj.tenant) {
            this.tenant = new Tenant(obj.tenant);
        }
    }
}